module.exports = __webpack_public_path__ + "icon_coffee_cup.dcf498fe857b388644c53470f94d7b59.svg";